<div class="inbox-datatable__main-content cv-inbox_intelligence scrollable-component scrollable">
	<div class="inbox-filter__content">
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">Status</label>
				<cv-multiselect
					[options]="orderStates"
					[values]="inboxFilterForm.orderStates"
					[optionText]="'name'"
					[optionValue]="'id'"
					[placeholder]="'Select status'"
					(valuesChange)="onOrderStateValueChange($event)"
				>
				</cv-multiselect>
			</div>
		</div>
		<div class="filter filter-external-id">
			<div class="input-filter__container">
				<cv-input
					[label]="'Reference ID'"
					[type]="'text'"
					[name]="'referenceID'"
					[placeholder]="'Reference ID'"
					[value]="inboxFilterForm.referenceID"
					(controlKeyup)="onReferenceIDValueChange($event)"
				></cv-input>
			</div>
		</div>
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">User</label>
				<cv-dropdown
					[placeholder]="'Select user'"
					[options]="profileList"
					[selectedValue]="inboxFilterForm.profileSelected"
					[optionText]="'name'"
					(valuesChange)="onProfilesValueChange($event)"
				>
				</cv-dropdown>
			</div>
		</div>
		<div class="filter">
			<div class="input-filter__container">
				<cv-input
					[label]="'Address'"
					[type]="'text'"
					[name]="'address'"
					[placeholder]="'Order Address'"
					[value]="inboxFilterForm.address"
					(controlKeyup)="onAddressValueChange($event)"
				></cv-input>
			</div>
		</div>
		<div class="filter filter-date">
			<div class="input-date-filter__container">
				<div class="cv-input">
					<label>Start Date</label>
				</div>
				<cv-datepicker-two
					[inline]="false"
					[dateFormat]="'yy-mm-dd'"
					[icon]="'fa fa-calendar-alt'"
					[(value)]="inboxFilterForm.startDate"
					[placeholder]="'Start Date'"
					(valueChange)="onDateSelect()"
					[selectionMode]="'single'"
				></cv-datepicker-two>
			</div>
		</div>
		<div class="filter filter-date">
			<div class="input-date-filter__container">
				<div class="cv-input">
					<label>End Date</label>
				</div>
				<cv-datepicker-two
					[inline]="false"
					[dateFormat]="'yy-mm-dd'"
					[icon]="'fa fa-calendar-alt'"
					[(value)]="inboxFilterForm.endDate"
					[placeholder]="'End Date'"
					(valueChange)="onDateSelect()"
					[selectionMode]="'single'"
				></cv-datepicker-two>
			</div>
		</div>
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">Filter SSR</label>
				<cv-dropdown
					[placeholder]="'Select Option'"
					[options]="filterSSR"
					[selectedValue]="inboxFilterForm.ssrFilterOrders"
					[optionText]="'name'"
					(valuesChange)="filterSsrRules($event)"
				>
				</cv-dropdown>
			</div>
		</div>
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">Form Type</label>
				<cv-multiselect
					[options]="formList"
					[values]="inboxFilterForm.formType"
					[optionText]="'name'"
					[optionValue]="'id'"
					[placeholder]="'Select FormType'"
					(valuesChange)="filterForm($event)"
				>
				</cv-multiselect>
			</div>
		</div>
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">Client</label>
				<cv-tracking-client-dropdown (trackingClientsChange)="onTrackingClientsChange($event)">
				</cv-tracking-client-dropdown>
			</div>
		</div>
		<div class="filter filter-select">
			<div class="multiselect-filter__container">
				<label class="select-lbl">Smart QC</label>
				<cv-multiselect
					[options]="smartQC"
					[values]="inboxFilterForm.smartQC"
					[optionText]="'name'"
					[optionValue]="'id'"
					[placeholder]="'Select Smart QC'"
					(valuesChange)="filterSmartQC($event)"
				>
				</cv-multiselect>
			</div>
		</div>
	</div>
	<hr class="separator" />
	<ag-grid-angular
		class="ag-theme-balham"
		#inboxGrid
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		(rowDataChanged)="onRowDataChanged()"
		[pagination]="true"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		(selectionChanged)="onSelectionChanged()"
		[rowData]="orderList"
	>
	</ag-grid-angular>
	<cv-grid-pagination
		[pagination]="inboxFilterForm.pagination"
		(onPaginationChange)="onPaginationChange($event)"
	></cv-grid-pagination>
</div>
<cv-resubmit></cv-resubmit>
<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
